module.exports = __webpack_public_path__ + "img/cover_3.fda80942.png";